import { render } from "./PackageOrderWholesalerPricingImportWrapper.vue?vue&type=template&id=3cc5a4a8"
import script from "./PackageOrderWholesalerPricingImportWrapper.vue?vue&type=script&lang=js"
export * from "./PackageOrderWholesalerPricingImportWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__